"use client";

export { default as ConfigProvider } from "./config-provider"